import React from 'react';

//import {ReactComponent as ArrowUpIcon} from 'assets/svg/arrow_up.svg';
import styles from 'css_modules/HistoryDetail.module.css';

export const HistoryDetail = ({log}) => {

        try {
            log.data = log.data.filter(row => row[0] !== 'embedding');
        } catch (error) {}
        
        console.log(log.data)
        const changes = JSON.parse(JSON.stringify(log.data));

        const getDetailHeaderText = () => {
            switch (log.event.id) {
                case 'rej':
                    return 'Komentář';
                case 'imp':
                case 'chn':
                    return 'Číslo v účetním systému';
                case 'err':
                    return 'Zpráva o chybě';
                case 'crt':
                    return 'ID dokladu';
                case 'upl':
                    return 'Název souboru';
                case 'tts':
                    return 'Časové razítko';
                case 'aat':
                    return 'Název souboru';
                case 'dat':
                    return 'Název souboru';
                case 'watchdocs':
                    return 'ID aplikace';
                case 'mobile':
                    return 'ID aplikace';
                case 'ttsaat':
                    return 'Časové razítko (příloha)';
                case 'isdoc':
                    return 'Vyplnění údaje z ISDOC dokladu';
                case 'isdcst':
                    return 'Vyplnění nákladů z ISDOC dokladu';
                case 'remitm':
                    return 'Položka smazána';
                case 'chaut':
                    return 'Uživatelský typ dokladu';    
                case 'eml':
                    return 'Email';
                case 'tpl':
                    return 'Zdrojový doklad';
                case 'cpterr':
                    return 'Chyba';
                default:
                    throw new Error(`Unreachable: ${log.event.id}`);
            }
        };

        const getChangeRowClassName = index => changes.length === index + 1 ? styles.changeBottom : styles.changeRow;

        const renderChanges = (field, index) => (
            <tr key={index} className={getChangeRowClassName(index)}>
                <td>{field[0]}:</td>
                <td className={styles.greyText}>{log.data[0][0] === 'Přenesená daňová povinnost' ? (field[1] ? 'ANO' : 'NE') : field[1]}</td>
                <td className={styles.greyText}>{log.data[0][0] === 'Přenesená daňová povinnost' ? (field[2] ? 'ANO' : 'NE') : field[2]}</td>
            </tr>
        );

        const renderItemChanges = (field, index) => {
            const isMetaText = String(field[0]) === "_meta_Text";
            const startsWithMeta = String(field[0]).startsWith("_meta");
            
            if (field[0] === 'id' || (!isMetaText && startsWithMeta)) {
                return null;
            }
            
            return (
                <tr key={index} className={getChangeRowClassName(index)}>
                    <td>{isMetaText ? "Původní název" : field[0]}:</td>
                    <td className={styles.greyText}>{(field[1] === true ? 'ANO' : field[1] === false ? 'NE' : field[1])}</td>
                    <td className={styles.greyText}>{(field[2] === true ? 'ANO' : field[2] === false ? 'NE' : field[2])}</td>
                </tr>
            );
        };

        const renderItemCreated = (field, index) => {
            if (field[0] === 'id' || field[1] === "" || field[1] === null) {
                return null;
            }

            return (
                <tr key={index} className={getChangeRowClassName(index)}>
                    <td>{field[0]}:</td>
                    <td className={styles.greyText}>{'---'}</td>
                    <td className={styles.greyText}>{(field[1] === true ? 'ANO' : field[1] === false ? 'NE' : field[1])}</td>
                </tr>
            );
        };

        const renderItemRemoved = (field, index) => {
            if (field[0] === 'id' || field[1] === "" || field[1] === null) {
                return null;
            }

            return (
                <tr key={index} className={getChangeRowClassName(index)}>
                    <td>{field[0]}:</td>
                    <td className={styles.greyText}>{(field[1] === true ? 'ANO' : field[1] === false ? 'NE' : field[1])}</td>
                    <td className={styles.greyText}>{''}</td>
                </tr>
            );
        };

        switch (log.event.id) {
            case 'cha':
            case 'isdoc':
            case 'chaitm':
                return (
                    <>
                        <tr className={styles.changeHeader}>
                            <td></td>
                            <td>Původní hodnota</td>
                            <td>Nová hodnota</td>
                        </tr>
                        {changes.map(renderItemChanges)}
                    </>
                );
            case 'crtitm':
                return (
                    <>
                        <tr className={styles.changeHeader}>
                            <td></td>
                            <td>Původní hodnota</td>
                            <td>Nová hodnota</td>
                        </tr>
                        {changes.map(renderItemCreated)}
                    </>
                );
            case 'remitm':
                return (
                    <>
                        <tr className={styles.changeHeader}>
                            <td></td>
                            <td>Hodnota</td>
                            <td></td>
                        </tr>
                        {changes.map(renderItemRemoved)}
                    </>
                );
            case 'chacpt':
                return (
                    <>
                        <tr className={styles.changeHeader}>
                            <td></td>
                            <td>Původní hodnota</td>
                            <td>Nová hodnota</td>
                        </tr>
                        {changes.map(renderChanges)}
                    </>
                );
            case 'isdcst':
            case 'cst':
            case 'cstcpt':
            case 'chaut':
                return (
                    <>
                        <tr className={styles.changeHeader}>
                            <td></td>
                            <td>Původní hodnota</td>
                            <td>Nová hodnota</td>
                        </tr>
                        {changes.map(renderChanges)}
                    </>
                );
            
            default:
                return (
                    <>
                        <tr className={styles.header}>
                            <td colSpan={5}>{getDetailHeaderText()}</td>
                        </tr>
                        <tr className={styles.bottom}>
                             <td colSpan={5} style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere" }}>
                                 {log.data}
                             </td>
                        </tr>
                    </>
                );
        }
    }
;